import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ICommentService } from 'vscode/vscode/vs/workbench/contrib/comments/browser/commentService.service';
import { CommentService } from './vscode/src/vs/workbench/contrib/comments/browser/commentService.js';
import './vscode/src/vs/workbench/contrib/comments/browser/comments.contribution.js';

function getServiceOverride() {
    return {
        [( ICommentService.toString())]: new SyncDescriptor(CommentService, [], true)
    };
}

export { getServiceOverride as default };
